import React, { forwardRef, useImperativeHandle } from 'react';
import { Modal } from 'antd';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { useAppDispatch } from '@/store/hooks/useAppDispatch';
import { getSelectedAgentId } from '@/store/account/selector';
import { useWorkflowModal } from 'src/Hooks/useWorkflowModal';
import { useCalendarBookingLogic } from 'src/Hooks/useCalendarBookingLogic';
import CalendarBookingFormContent from './components/CalendarBookingFormContent';
import {
	ICalendarBookingModalProps,
	ICalendarBookingModalRef,
} from '@/interfaces/ICalendarWorkflows';

const CalendarBookingModal = forwardRef<ICalendarBookingModalRef, ICalendarBookingModalProps>(
	(
		{ clientObject, mutation, refetch, debrand = false, isNoviUser = false, onCloseCallback },
		ref,
	) => {
		const selectedAgentId = useAppSelector(getSelectedAgentId);
		const dispatch = useAppDispatch();

		const { form, isVisible, isEditing, currentWorkflow, openModal, closeModal } =
			useWorkflowModal();

		const { handleSubmit, getDefaultFormValues, getEditFormValues } = useCalendarBookingLogic({
			clientObject,
			mutation,
			refetch,
			selectedAgentId,
			dispatch,
			closeModal,
		});

		useImperativeHandle(ref, () => ({ open: openModal }));

		const handleCancel = () => {
			if (onCloseCallback) {
				onCloseCallback();
			}
			closeModal();
		};

		return (
			<Modal
				title={isEditing ? 'Edit Calendar Booking Workflow' : 'Add Calendar Booking Workflow'}
				open={isVisible}
				onCancel={handleCancel}
				footer={null}
				width={600}
				destroyOnClose
			>
				<CalendarBookingFormContent
					form={form}
					isEditing={isEditing}
					currentWorkflow={currentWorkflow}
					onSubmit={handleSubmit}
					onCancel={handleCancel}
					mutation={mutation}
					debrand={debrand}
					isNoviUser={isNoviUser}
					getDefaultFormValues={getDefaultFormValues}
					getEditFormValues={getEditFormValues}
				/>
			</Modal>
		);
	},
);

CalendarBookingModal.displayName = 'CalendarBookingModal';
export default CalendarBookingModal;
